// extracted by mini-css-extract-plugin
export default {"container":"stats_container__2B2-0","isContainer":"stats_isContainer__2rhB_","box":"stats_box__1JImK","stats":"stats_stats__aRE6b"};